import React from 'react'

import OldSignin from './old-signin'
import NewSignin from './new-signin'
import { ISignin } from './types'

/**
 * Hard switch between the two sign-in implementations. Build-time flag, so an unset or
 * false value renders today's page unchanged. That is the kill switch.
 */
const Signin = (props: ISignin): React.ReactElement => {
  const shouldUseNewFlow = process.env.REACT_APP_USE_NEW_SIGNIN_SIGNUP === 'true'
  if (shouldUseNewFlow) {
    return <NewSignin location={props.location} />
  }

  return <OldSignin {...props} />
}

export default Signin
